import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from "react-currency-format";
import reseller from "web/assets/images/reseller.png";
import premium_star from "web/assets/images/premium_star.png";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "styled-components";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";
import { useHistory } from "react-router-dom";
import Spinner from "web/components/Spinner";
import Button from "web/components/Button";
import Timmer from "web/components/Timmer";
import AlertModal from "web/components/AlertModal";
// import PalletsImg from "web/assets/images/pallet-home-image.webp";
import PalletsImg from 'web/assets/images/pallet-home-image.jpg';
import locationicon from "web/assets/images/location-icon.png";
import clockicon from "web/assets/images/clock-icon.png";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderOutlinedIcon from "@material-ui/icons/FavoriteBorderOutlined";
import UploadDummy from "web/assets/images/UploadDummy.png";
import { favoriteIconAPI } from "redux/actions/postLoad";
import { postInventorySearchById } from "redux/actions/postInventory";
import styles from "../details.module.scss";
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import RightArrowLight from "web/assets/images/right-arrow-sell.png";
import { downloadFile } from "redux/actions/helper/downloadFile";

const InventoryDetails = ({ pageId, postType, pageLanguageContents }) => {
  const [response, setResponse] = useState(undefined);
  let history = useHistory();
  const dispatch = useDispatch();
  const cardExpiryDetails = useSelector(
    (state) => state.authReducer.cardExpiryDetails
  );
  const urlObject = useSelector((state) => state.urlParameters.details);

  const fileUrl = process.env.REACT_APP_API_URL + "/user/image/";

  const [loginType, setLoginType] = useState(false);

  const [btnDisable, setBtnDisable] = useState(false);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const token = localStorage.getItem("token");

  let officeDaysArr = ["M", "T", "W", "Th", "F", "Sat", "Sun"];
  const [dayOfWeeks, setDayOfWeeks] = useState(officeDaysArr);
  const [officeHour, setOfficeHour] = useState({
    officeHourStart: "",
    officeHourEnd: "",
  });

  //To fetch inventory details on component render 
  useEffect(() => {
    if (pageId && postType) fetchMyAPI({ pageId, postType })
  }, [])

  //helper function to convert time format
  const tConvert = (time) => {
    if (time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1);

        time[3] = undefined // removing the seconds
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        // time[3] = +"";
        // time[2] = +"";
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join("");
    }
  };

  // Function to get inventory by ID 
  const fetchMyAPI = async ({ pageId, postType }) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      const data = {
        authId: localStorage.getItem('authId'),
        inventoryId: pageId
      }
      const response = await dispatch(postInventorySearchById(data, token));
      if (response.success) {
        if (response.data) {
          // even if post is not available, post created user and bidded user should be able to view the post
          let isPostCreatedUser = false, isBiddedUser = false
          let loggedInLocation = localStorage.getItem('locationID')
          isPostCreatedUser = response.data?.userDetails?.locationsId?.filter(val => val === loggedInLocation)?.length > 0 ? true : false

          if (urlObject?.prevPage === 'offer' && response.data?.status === 'ACCEPTED') isBiddedUser = true

          let obj = {
            id: urlObject?.id?.toString(),
            postType: 'PostInventory',
          }
          dispatch({ type: 'DETAILS', payload: obj })

          let obj1 = {
            title: '',
            params: 'true',
            pageType: "PostInventory",
            expanded: 'sideBar',
            tabType: ''
          }
          dispatch({ type: 'SEARCH_INVENTORY', payload: obj1 })

          if ((response.data.status !== 'AVAILABLE' && response.data.status !== 'PENDING_HANDSHAKE') && (!isPostCreatedUser && !isBiddedUser)) {
            setModalContent("This post is no longer available. Check out others on the marketplace.");
            setModalLink("/nearby-inventory");
            toggleModal();
          } else {
            setResponse(response.data);
            if (response?.data?.userDetails?.locationsId?.includes(localStorage.getItem("locationID"))) {
              setLoginType(true);
            }

            //To set and reformat days of operations
            if (response?.data?.daysOfOperations) {
              let dayArr = [];
              for (let i = 0; i < response?.data?.daysOfOperations?.length; i++) {
                if (response?.data?.daysOfOperations[i] === "MONDAY") {
                  dayArr.push("M");
                } else if (response?.data?.daysOfOperations[i] === "TUESDAY") {
                  dayArr.push("T");
                } else if (response?.data?.daysOfOperations[i] === "WEDNESDAY") {
                  dayArr.push("W");
                } else if (response?.data?.daysOfOperations[i] === "THURSDAY") {
                  dayArr.push("Th");
                } else if (response?.data?.daysOfOperations[i] === "FRIDAY") {
                  dayArr.push("F");
                } else if (response?.data?.daysOfOperations[i] === "SATURDAY") {
                  dayArr.push("Sat");
                } else if (response?.data?.daysOfOperations[i] === "SUNDAY") {
                  dayArr.push("Sun");
                }

                if (response?.data?.daysOfOperations.length - 1 === i) {
                  setDayOfWeeks(dayArr);
                }
              }
            }

            setOfficeHour({
              ...officeHour,
              officeHourStart: tConvert(response?.data?.operationsHourStart),
              officeHourEnd: tConvert(response?.data?.operationsHourEnd),
            });

            if (response.data.status === "BIDDING_CLOSE") {
              setBtnDisable(true);
            }
          }
        }
      } else if (response?.error?.message === "You are not authorized to view this post") {
        setModalContent(response?.message);
        setModalLink(
          postType === "PostInventory"
            ? "/nearby-inventory"
            : "/nearby-needs"
        );
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };



  const onClickHandler = (response, postButtonType) => {
    let obj = {
      id: response?.id?.toString(),
      type: 'buyerInvCheckout' + postButtonType,
      palletDetails: response?.palletDetails
    }
    dispatch({ type: 'CHECKOUT', payload: obj })
    history.push({ pathname: '/checkout', })
  };

  const addTofavorite = async (response) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let isFavoriteFlag = true;
      if (response?.favorite) {
        isFavoriteFlag = false;
      }

      let data = {
        postId: response?.id,
        postType: "INVENTORY",
        isFavorite: isFavoriteFlag,
      };

      let addToFavoriteResponse = await dispatch(favoriteIconAPI(data, token));
      if (addToFavoriteResponse?.success) {
        setModalContent(addToFavoriteResponse?.data?.msg);
        setModalLink("");
        toggleModal();

        fetchMyAPI({ pageId, postType });
        if (addToFavoriteResponse?.data) {
        }
      } else {
        if (addToFavoriteResponse.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(addToFavoriteResponse?.data?.error?.message || addToFavoriteResponse?.data?.message || addToFavoriteResponse?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const vehiclePreferencesFun = (vehiclePreferences) => {
    let vehicles = "";
    if (vehiclePreferences.includes("FLAT_BED")) {
      vehicles = "Flatbed";
    }
    if (vehiclePreferences.includes("VAN") && vehicles.length > 0) {
      vehicles = vehicles + ", Van";
    } else if (vehiclePreferences.includes("VAN")) {
      vehicles = "Van";
    }
    if (vehiclePreferences.includes("STRAIGHT") && vehicles.length > 0) {
      vehicles = vehicles + ", Straight Truck";
    } else if (vehiclePreferences.includes("STRAIGHT")) {
      vehicles = "Straight Truck";
    }
    return vehicles;
  };

  let condition = [];
  if (response) {
    for (let i = 0; i < response?.palletDetails?.condition?.length; i++) {
      condition.push(response?.palletDetails?.condition[i]);
    }
  }

  let newConditionType
  if (response?.palletDetails?.newConditionType) {
    if (response?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
    else if (response?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
  }
  const generatePdfDocument = async (imagePath) => {
    // const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
    // window.open(fileUrl);
    dispatch(downloadFile(imagePath));
  };

  const ratingSection = () => {
    if (response?.userDetails?.fcMember) {
      return (
        <RatingSection>
          <div>{pageLanguageContents?.PalletDetails[5]?.Rating}</div>{" "}
          <Box component="fieldset" mb={3} borderColor="transparent">
            <Rating
              readOnly
              name="simple-controlled"
              value={5}
              onChange={(event, newValue) => { }}
            />
          </Box>
        </RatingSection>
      );
    } else {
      return (
        <RatingSection>
          <div>{pageLanguageContents?.PalletDetails[5]?.Rating}</div>{" "}
          <Box component="fieldset" mb={3} borderColor="transparent">
            <Rating
              name="simple-controlled"
              readOnly
              onChange={(event, newValue) => { }}
            />
          </Box>
        </RatingSection>
      );
    }
  };

  const makeOfferBtn = (response) => {
    return (
      <div
        onClick={(e) => {
          if (!btnDisable) onClickHandler(response, "makeOffer");
        }}
      >
        <Button
          type="app-green-button"
          disabled={btnDisable}
        >
          {pageLanguageContents?.PalletDetails[23]?.PlaceBid}
        </Button>
      </div>
    );
  }

  const buyNowPickupBtn = (response) => {
    return (
      <div
        onClick={(e) => {
          if (!btnDisable) onClickHandler(response, "buynowcpu");
        }}
      >
        <Button
          type="app-green-button"
          disabled={btnDisable || cardExpiryDetails.buyerCardExpired}
        >
          {pageLanguageContents?.PalletDetails[25]?.BuyPickup}
        </Button>
      </div>
    );
  };

  const makeAltOfferBtn = (response) => {
    return (
      <div
        onClick={(e) => {
          if (!btnDisable) onClickHandler(response, "makeAltOffer");
        }}
      >
        <Button
          type="app-green-button"
          disabled={btnDisable || cardExpiryDetails.buyerCardExpired}
        >
          {pageLanguageContents?.PalletDetails[38]?.MakeOffer}
        </Button>
      </div>
    );
  };

  const buyNowDelivery = (response) => {
    return (
      <>
        <div
          onClick={(e) => {
            if (!btnDisable) onClickHandler(response, "buynow");
          }}
        >
          <Button
            type="app-green-button"
            disabled={btnDisable}
          >
            {pageLanguageContents?.PalletDetails[24]?.BuyDelivery}
          </Button>
        </div>
      </>
    );
  };


  const postInventoryBtns = () => {
    if (!loginType) {
      if (response?.offerAlreadyMade) {
        if (response?.offerTypeByUser === "OFFER" || response?.offerTypeByUser === "ALTOFFER") {
          return (
            <>
              {(response.buyNowPickupPrice && response.buyNowPickupPrice !== 0) ? buyNowPickupBtn(response) : ""}
              {(response.distanceWillingToTravel && response.buyNowDeliveredPrice && (response.buyNowDeliveredPrice !== 0)) ? buyNowDelivery(response) : ""}
            </>
          );
        } else {
          return <p>Offer Already Made.</p>;
        }
      } else {
        return (
          <>
            {makeOfferBtn(response)}
            {(response.buyNowPickupPrice && response.buyNowPickupPrice !== 0) ? buyNowPickupBtn(response) : ""}
            {(response.buyNowDeliveredPrice && (response.buyNowDeliveredPrice !== 0)) ? buyNowDelivery(response) : ""}
            {response?.allowAltOffer && makeAltOfferBtn(response)}
          </>
        );
      }
    } else {
      return "";
    }
  };

  const isDeliverable = () => {
    if (response && response?.shippingMode === "DELIVERY") {
      return (
        <div>
          <div className="distance-col icon-col">
            <img src={locationicon} alt="" Location />
          </div>
          <div class="d-text">
            {response && response.distanceWillingToTravel ? (
              <h3>
                {response.distanceWillingToTravel}{" "}
                {pageLanguageContents?.PalletDetails[27]?.Miles}{" "}
                <PerPalletsText>
                  <b> {pageLanguageContents?.PalletDetails[28]?.Radius}</b>
                </PerPalletsText>
              </h3>
            ) : (
              <h3>{pageLanguageContents?.PalletDetails[29]?.No}</h3>
            )}
            <p>
              {pageLanguageContents?.PalletDetails[30]?.DistanceWillTravel}
            </p>
          </div>
        </div>
      );
    }
  };
  const clockiconAttach = () => {
    if (response && response.deliveryLeadTime) {
      return (
        <h3 className="clock-col">
          {response.deliveryLeadTime === 1 ? 'No lead time' :
            <>{response.deliveryLeadTime} {" "}
              {/* {pageLanguageContents?.PalletDetails[31]?.Hours} */}
            </>}
        </h3>
      );
    } else {
      return <h3>{pageLanguageContents?.PalletDetails[15]?.NA}</h3>;
    }
  };
  const deliveryAvailableAttach = () => {
    if (response?.shippingMode === 'DELIVERY' && response?.vehiclePreferences !== undefined) {
      return <h3>{vehiclePreferencesFun(response?.vehiclePreferences)}</h3>;
    } else {
      return <h3>Pickup</h3>;
    }
  };
  const capitalize = (s) => {
    if (typeof s !== 'string')
      return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  const getCommodity = () => {
    let commodityVal = "NA";
    if (response?.palletDetails?.palletType) commodityVal = capitalize(response?.palletDetails?.palletType.toLowerCase())
    else if (response?.palletDetails?.material === 'PLASTIC') commodityVal = 'Plastic'
    else if (response?.palletDetails?.material === 'OTHER') commodityVal = 'Custom'
    return (
      <div>
        <h3>{commodityVal}</h3>
        <p>{pageLanguageContents?.PalletDetails[10]?.Commodity}</p>
      </div>
    );
  };

  const getGradeName = () => {
    let gradeName = "NA";
    if (response?.palletDetails?.grade) {
      gradeName = response?.palletDetails?.grade;
    }

    return (
      <>
        {
          <div>
            <h3>{gradeName}</h3>
            <p>{pageLanguageContents?.PalletDetails[11]?.Grade}</p>
          </div>
        }
      </>
    );
  };
  const isHeatTreared = () => {
    let isHeatTrearedVal = "No";
    if (response?.palletDetails?.heatTreared) {
      isHeatTrearedVal = "Yes";
    }
    return (
      <div className="pl-md-2 pl-sm-0">
        <h3>{isHeatTrearedVal}</h3>
        <p>Heat Treated</p>
      </div>
    );
  };
  const gradeSize = () => {
    let commodityDim = "NA";
    if (
      response?.palletDetails?.length &&
      response?.palletDetails?.width &&
      response?.palletDetails?.height
    ) {
      let length = response?.palletDetails?.length;
      let width = "x" + response?.palletDetails?.width;
      let height = "x" + response?.palletDetails?.height;

      commodityDim = length + "" + width + "" + height;
      if (
        !response?.palletDetails?.length &&
        !response?.palletDetails?.width &&
        !response?.palletDetails?.height
      ) {
        commodityDim = "NA";
      }
    } else {
      if (response?.palletDetails?.size) {
        commodityDim = response?.palletDetails?.size;
      }
      else {
        if (response?.palletDetails?.grade) {
          commodityDim = response?.palletDetails?.grade;
        }
      }
    }
    return (
      <div>
        <h3>{commodityDim}</h3>
        <p>Size</p>
      </div>
    );
  };

  const specficationDocFiles = () => {
    if (response?.specificationFiles) {
      return (
        <>
          {response?.specificationFiles.map((spectItems, i) => (
            <Tooltip
              placement="top"
              arrow
              title={spectItems?.orignalFileName}
              enterTouchDelay={0}
            >
              <UploadSpec
                className="upload"
                onClick={() => {
                  generatePdfDocument(spectItems?.fileName);
                }}
              >
                <img src={UploadDummy} alt="upload Dummy" />
                <span style={{ cursor: 'pointer' }}>{spectItems?.orignalFileName}</span>
              </UploadSpec>
            </Tooltip>
          ))}
        </>
      );
    } else if (response.specificationFile) {
      return (
        <>
          {response.specificationFile.map((spectItems, i) => (
            <Tooltip
              placement="top"
              arrow
              title={spectItems.fileName}
              enterTouchDelay={0}
            >
              <UploadSpec
                className="upload"
                onClick={() => {
                  generatePdfDocument(spectItems.fileName);
                }}
              >
                <img src={UploadDummy} alt="upload Dummy" />
                <span>{spectItems.orignalFileName}</span>
              </UploadSpec>
            </Tooltip>
          ))}
        </>
      );
    }
  };
  let bidCloseTimeUTC = false;
  if (response?.postPreferences?.bidCloseTimeEpocSeconds - Date.now() / 1000 > 0) {
    bidCloseTimeUTC = true;
  }
  return (
    <>
      {loaderVisible && <Spinner />}
      {response && (<div className={styles.textSection}>
        <Description>
          <div className="product-header-sec">
            {postType === "PostLoad" && (
              <img
                src={RightArrow}
                alt="RightArrow"
                className="right-arrow"
              />
            )}
            {postType === "PostInventory" && (
              <img
                src={RightArrowLight}
                alt="RightArrow"
                className="right-arrow"
              />
            )}
            {/* } */}
            <div className="product-header-title">
              <Title>
                {response?.postTitle}
                <PrivatePost className="">
                  {response?.postPreferences?.postingMethod !== "MARKET" && "Private Post"}
                </PrivatePost>
              </Title>
              <SubTitle>{response.comments}</SubTitle>
            </div>
            <ProductHeaderReseller>
              {/* {response?.postRecurrence?.length > 0 && (
                  <>
                    <span className={styles.purple}>
                      Recurring Post
                    </span>
                  </>
                )} */}
              {response?.userDetails?.userRole === "BROKER" && (
                <SellerIconWrapper>
                  <div>
                    <img src={reseller} alt="reseller" />
                    <p style={{ lineHeight: "10px" }}>
                      {pageLanguageContents?.PalletDetails[0]?.Reseller}
                    </p>
                  </div>
                </SellerIconWrapper>
              )}
              <StarIconWrapper>
                <div>
                  <img
                    src={premium_star}
                    hidden={!response?.userDetails?.fcMember}
                    alt="fcMember"
                  />
                </div>
              </StarIconWrapper>
            </ProductHeaderReseller>
          </div>
        </Description>
        <InnerWrapper>
          <div className={styles.imageSection}>
            <div
              className={`${postType === "PostInventory"
                ? styles.productImage
                : styles.productImageDark
                } d-none d-md-block`}
            >
              <PalletsWrapper>
                <Pallets>
                  <div className={`d-inline-flex pallete-image p-2 ${postType === "PostInventory"
                    ? styles.borderLightBlue
                    : styles.borderDarkBlue
                    }`}>
                    <img
                      src={
                        response?.postImageFiles && response.postImageFiles.length > 0
                          ? `${fileUrl}${response.postImageFiles[0].fileName}`
                          : PalletsImg
                      }
                      alt="Pallets"
                    />
                  </div>
                </Pallets>
              </PalletsWrapper>
            </div>

            <div className={styles.sellerInfo}>
              <div>
                {/* {(response?.userDetails?.userRole === "BROKER") || (localStorage.getItem('accountType') === "Guest") || (localStorage.getItem('accountType') === "Reseller") ? (
                  <h6>Seller Zip Code:</h6>
                ) : <h6>Seller Info:</h6>
                } */}
                <h6>Seller Located Near:</h6>
                <p onClick={() => addTofavorite(response)}>
                  {'Favorite'}{" "}
                  &nbsp;
                  {response && response.favorite ? (
                    <FavoriteIcon style={{ color: "#cd181d" }} />
                  ) : (
                    <FavoriteBorderOutlinedIcon />
                  )}
                </p>
              </div>
              <div className={styles.info}>
                <address>
                  {/* {(localStorage.getItem('accountType') === "Guest") || (localStorage.getItem('accountType') === "Reseller") ? (
                    <>
                    <p>
                      {pageLanguageContents?.PalletDetails[4]?.ZipCode}{" "}
                      {response?.userDetails?.zipCode}
                    </p>
                    </>
                  ) : (
                    <>
                      {response?.userDetails?.userRole === "BROKER" ? (
                        <p>
                          {pageLanguageContents?.PalletDetails[4]?.ZipCode}{" "}
                          {response?.userDetails?.zipCode}
                        </p>
                      ) : (
                        <>
                          <h6 hidden={!response?.userDetails?.fcMember}>
                            {response?.userDetails?.companyName}
                          </h6>

                          <h5
                            hidden={response?.userDetails?.fcMember}
                            style={{ fontWeight: "bold" }}
                          >
                            {response?.userDetails?.companyName}
                          </h5>

                          {response?.userDetails?.address1 && <p>{response?.userDetails?.address1}&nbsp;</p> }
                          {response?.userDetails?.address2 && <p>{response?.userDetails?.address2}</p> }
                          <p>
                            {response?.userDetails?.city},&nbsp;
                            {response?.userDetails?.state}&nbsp;
                            {response?.userDetails?.zipCode}
                          </p>
                        </>
                      )}
                    </>
                  )} */}
                  {/* <p>
                    {pageLanguageContents?.PalletDetails[4]?.ZipCode}{" "}
                    {response?.userDetails?.zipCode}
                  </p> */}
                  <p>
                    {response?.userDetails?.city},&nbsp;
                    {response?.userDetails?.state}&nbsp;
                    {response?.userDetails?.zipCode}
                  </p>
                </address>

                <div className={styles.checkboxContainer}>
                  <p>Operating Days-&nbsp;</p>
                  {dayOfWeeks?.map((value, i) => (
                    <p style={{ color: "#30698d" }} key={i}>
                      {value}
                      {dayOfWeeks.length - 1 !== i && ","}&nbsp;
                    </p>
                  ))}
                </div>

                <div className={styles.checkboxContainer}>
                  <p>Operating Hours-&nbsp;</p>
                  <p>
                    {tConvert(officeHour.officeHourStart)} -{" "}
                    {tConvert(officeHour.officeHourEnd)}
                  </p>
                </div>
                {ratingSection()}
              </div>
            </div>
          </div>
          <TextInnerSection>
            <div className="d-block d-md-none">
              <PalletsWrapper>
                <Pallets>
                  <div>
                    <img
                      src={
                        response?.postImageFiles && response.postImageFiles.length > 0
                          ? `${fileUrl}${response.postImageFiles[0].fileName}`
                          : PalletsImg
                      }
                      alt="Pallets"
                    />
                  </div>
                </Pallets>
              </PalletsWrapper>
            </div>
            <div className={styles.condition}>
              <div>
                {condition.length === 1 && <h3>{capitalize(condition[0].toLowerCase())} {newConditionType && newConditionType}</h3>}
                {condition.length === 2 && (
                  <h3>{capitalize(condition[0].toLowerCase()) + "," + capitalize(condition[1].toLowerCase())} {newConditionType && newConditionType}</h3>
                )}
                {condition.length === 3 && (
                  <h3>
                    {capitalize(condition[0].toLowerCase()) +
                      "," +
                      capitalize(condition[1].toLowerCase()) +
                      "," +
                      capitalize(condition[2].toLowerCase())} {newConditionType && newConditionType}
                  </h3>
                )}
                {condition.length === 0 && (
                  <h3>
                    {pageLanguageContents?.PalletDetails[15]?.NA}
                  </h3>
                )}
                <p>
                  {pageLanguageContents?.PalletDetails[9]?.Condition}
                </p>
              </div>

              {getCommodity()}
              {gradeSize()}
              {getGradeName()}
              {isHeatTreared()}

              {response?.postType !== "NEED" && (
                <div className="pl-md-2 pl-sm-0">
                  {deliveryAvailableAttach()}
                  <p>Delivery Mode</p>
                </div>
              )}
            </div>

            <PriceSection>
              <PriceSectionBox>
                {response.displayCostToMarket && (
                  <div>
                    {response.targetPrice ? (
                      <>
                        <h3>
                          <CurrencyFormat
                            value={response.targetPrice.toFixed(2)}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                          />
                          &nbsp;
                          <PerPalletsText>
                            <span>
                              {pageLanguageContents?.PalletDetails[14]?.PerPallet}
                            </span>
                          </PerPalletsText>
                        </h3>
                      </>
                    ) : (
                      <h3>
                        {pageLanguageContents?.PalletDetails[15]?.NA}
                      </h3>
                    )}
                    <p>
                      {pageLanguageContents?.PalletDetails[17]?.TargetPrice}
                    </p>
                  </div>
                )}
                <div>

                  {response.shippingMode === "DELIVERY" &&
                    response.buyNowDeliveredPrice ? (
                    <>
                      <h3>
                        <CurrencyFormat
                          value={response.buyNowDeliveredPrice.toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                        &nbsp;
                        <PerPalletsText>
                          <span>
                            {pageLanguageContents?.PalletDetails[14]?.PerPallet}
                          </span>
                        </PerPalletsText>
                      </h3>
                    </>
                  ) : (
                    <h3>
                      {pageLanguageContents?.PalletDetails[15]?.NA}
                    </h3>
                  )}


                  <p>
                    {pageLanguageContents?.PalletDetails[16]?.DeliveryPrice}
                  </p>
                </div>
                <div>
                  {response.shippingMode === "DELIVERY" &&
                    response.buyNowPickupPrice ? (
                    <>
                      <h3>
                        <CurrencyFormat
                          value={response.buyNowPickupPrice.toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                        &nbsp;
                        <PerPalletsText>
                          <span>
                            {pageLanguageContents?.PalletDetails[14]?.PerPallet}
                          </span>
                        </PerPalletsText>
                      </h3>
                    </>
                  ) : (
                    <>
                      {response.displayCostToMarket &&
                        response.buyNowPickupPrice ? (
                        <>
                          <h3>
                            <CurrencyFormat
                              value={
                                response.buyNowPickupPrice
                                  ? response.buyNowPickupPrice.toFixed(2)
                                  : 0
                              }
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                            />
                            &nbsp;
                            <small className={styles.perPallet}>
                              {" "}
                              {pageLanguageContents?.PalletDetails[14]?.PerPallet}
                            </small>
                          </h3>
                        </>
                      ) : (
                        <>
                          {response.pickupAllowed ? (
                            <>
                              <h3>
                                <CurrencyFormat
                                  value={
                                    response.buyNowPickupPrice
                                      ? response.buyNowPickupPrice.toFixed(2)
                                      : 0
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                                &nbsp;
                                <small className={styles.perPallet}>
                                  {" "}
                                  {pageLanguageContents?.PalletDetails[14]?.PerPallet}
                                </small>
                              </h3>
                            </>
                          ) : (
                            <h3>
                              {pageLanguageContents?.PalletDetails[15]?.NA}
                            </h3>
                          )}
                        </>
                      )}
                    </>
                  )}
                  <p>
                    {pageLanguageContents?.PalletDetails[18]?.PickupPrice}
                  </p>
                </div>
              </PriceSectionBox>
              <PriceSectionBox>
                <div>
                  {response && (
                    <h3>
                      {response?.totalQty.toLocaleString()}&nbsp;
                      {response?.lotPostingOption === "SINGLE" && <LotsText>
                        <>
                          ({response?.lots}{" "}
                          {pageLanguageContents?.PalletDetails[19]?.Lot}
                          )
                        </>
                      </LotsText>}
                    </h3>
                  )}
                  <p>
                    {pageLanguageContents?.PalletDetails[21]?.Quantity}
                  </p>
                </div>
                {bidCloseTimeUTC && (
                  <div>
                    <h3>
                      {
                        <Timmer
                          time={
                            response?.postPreferences?.bidCloseTimeEpocSeconds - Date.now() / 1000
                          }
                        />
                      }
                    </h3>
                    <p>
                      {pageLanguageContents?.PalletDetails[22]?.TimeLeft}
                    </p>
                  </div>
                )}
              </PriceSectionBox>
              {specficationDocFiles()}

              {(response?.status === "AVAILABLE") && <ActionSection>
                {postInventoryBtns()}
              </ActionSection>}
            </PriceSection>

            <TimeSection>
              {isDeliverable()}
              <div>
                <div className="time-col icon-col">
                  <img src={clockicon} alt="" Location />
                </div>
                <div class="d-text">
                  {clockiconAttach()}
                  <p>
                    Delivery Lead Time (Biz Days, M-F)
                  </p>
                </div>
              </div>
            </TimeSection>
            {/* {response.postRecurrence?.length > 0 && recurrenceTag()} */}
          </TextInnerSection>
        </InnerWrapper>
      </div>
      )}

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
};

export default InventoryDetails;

const Pallets = styled.div`
  text-align: center;
  background: #fff;
  padding: 0.5rem;
  > div {
    justify-content: center;
    display: flex;
    align-items: center;
    img {
      /* width: auto;
      max-height: 191px;
      max-width: 100%; */
      object-fit: contain;
      height: 240px;
      width: 260px;
      max-width: 100%;
    }
  }
`;
const PalletsWrapper = styled.div``;
const RatingSection = styled.div`
  font-family: "latoregular";
  display: flex;
  flex-direction: column;
  .MuiBox-root {
    margin-bottom: 0;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  color: #717171;
  font-family: "latobold";
  text-align: left;
  line-height: 27px;
  margin-bottom: 10px;
  padding-top: 13px;
  display: flex;
  align-items: center;
  gap: 0 10px;
  flex-wrap: wrap;
`;
const SubTitle = styled.p`
  font-size: 12px;
  color: #717171;
  font-family: "latoregular";
  margin: 0;
  word-break: break-all;
`;
const PrivatePost = styled.p`
  background: #ff6008;
  font-size: 12px;
  line-height: 1.67;
  color: #ffffff;
  padding: 0 6px;
  width: 78px;
`;

const Description = styled.div`
  position: relative;
  padding-left: 62px;
  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    /* @media (max-width: 767px) {
      grid-template-columns: 80% 1fr;
    } */
  }
`;
const SellerIconWrapper = styled.div`
  /* position: absolute;
  right: 0;
  top: 0; */
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  p {
    margin: 0;
    line-height: 12px;
  }
`;
const StarIconWrapper = styled.div`
  /* position: absolute;
  right: 55px;
  top: 0; */
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 25px;
    height: 25px;
  }
  p {
    margin: 0;
    line-height: 12px;
  }
`;

const PriceSection = styled.div`
  padding: 0px 0 28px;
  border-bottom: solid 1px #e1e1e1;
  margin-bottom: 13px;
  background: #fff;
  color: #717171;
`;
const PriceSectionBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-flow: row;
  grid-gap: 25px 0;
  margin-bottom: 15px;
  @media (max-width: 767px) {
    grid-template: none;
    margin-bottom: 5px;
    gap: 10px;
    > div {
      display: grid;
      grid-template-columns: 50% 1fr;
      gap: 5px 10px;
      align-items: self-start;
      h3 {
        font-size: 16px;
        grid-area: 1 / 2 / 2 / 3;
      }
      p {
        font-size: 16px;
        margin: 0;
      }
    }

    span {
      /* font-size: 20px; */
      font-size: 16px;
      font-family: "latoregular";
      color: #717171;
    }
  }

  h3 {
    font-size: 17px;
    font-family: "latosemibold";
    display: flex;
    align-items: center;
    line-height: 24px;
  }
  p {
    font-size: 12px;
    font-family: "latoregular";
    color: #717171;
    margin-bottom: 0;
    margin-top: 2px;
  }
`;
const ActionSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;
  margin-top: 29px;
  p {
    width: 150px;
  }
  button {
    padding: 8px 10px;
    width: 100%;
    font-size: 17px;
    border: none;
    font-family: "latoregular" !important;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    button {
      font-size: 14px;
    }
  }
`;
const TimeSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  padding: 15px 0;
  background: #fff;
  @media (max-width: 767px) {
    padding-bottom: 0;
    grid-auto-flow: unset;
    gap: 10px;
  }
  h3 {
    font-size: 16px;
    font-family: "latosemibold";
    color: #717171;
  }
  p {
    font-size: 12px;
    font-family: "latoregular";
    color: #717171;
    margin: 0;
    line-height: 27px;
  }
  & > div {
    display: flex;
    @media (max-width: 767px) {
      display: grid;
      grid-template-columns: 30px 1fr;
      gap: 10px;
      &.flow-column {
        grid-template-columns: 1fr 1fr;
        h3 {
          order: 2;
          font-size: 16px;
        }
        p {
          font-size: 16px;
          line-height: 1;
        }
      }
    }
    &.flow-column {
      flex-direction: column;
    }
    .icon-col {
      width: 26px;
      margin-right: 8px;
      &.distance-col {
        max-width: 18px;
      }
      img {
        max-width: 100%;
      }
    }
    .d-text {
      max-width: 190px;
      @media (max-width: 767px) {
        max-width: none;
        font-size: 16px;
        font-family: "latoregular";
        color: #717171;
      }
    }
  }
  @media (max-width: 767px) {
    h3 {
      /* font-size: 20px; */
      font-size: 16px;
      font-family: "latoregular";
      color: #717171;
    }
    p {
      font-size: 13px;
    }
  }
`;

const PerPalletsText = styled.small`
  color: #717171;
  line-height: 24px;
  font-size: 16px;
  font-family: "latosemibold";

  @media (max-width: 767px) {
    span{
      font-size: 16px;
      font-family: "latoregular";
      color: #717171;
    }
    font-size: 11px;
  }
`;

const InnerWrapper = styled.div`
  display: grid;
  grid-template-columns: 285px 1fr;
  grid-gap: 30px;
  margin-top: 24px;

  @media (max-width: 1250px) {
    grid-template-columns: 233px 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    grid-gap: 0;
    > div:first-child {
      order: 2;
    }
  }
`;
const TextInnerSection = styled.div``;
const UploadSpec = styled.div`
  display: flex;
  align-items: center;
  align-items: flex-start;
  /* span {
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    } */
  img {
    margin-right: 5px;
  }
`;

const ProductHeaderReseller = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
const LotsText = styled.small`
  line-height: 24px;
  color: #ff7f00;
  font-family: "latosemibold";

  @media (max-width: 767px) {
    font-size: 11px;
  }
`;